import { Model } from "survey-core";
import "survey-core/survey-core.min.css";
import { Survey } from "survey-react-ui";

import "@/styles/condensed-report.css";

export type CondensedReportSurveyProps = {
  model: Model;
  /** Adds the " editing" class the edit-mode CSS targets. */
  editing?: boolean;
  containerClassName?: string;
};

/**
 * Presentational renderer for a condensed report: the `.condensed-report`
 * wrapper plus the SurveyJS `<Survey>`. This is the single DOM surface that
 * `condensed-report.css` styles. It holds no data-fetching, dialog, menu, or
 * mode logic — callers build and own the model.
 */
const CondensedReportSurvey = ({
  model,
  editing = false,
  containerClassName,
}: CondensedReportSurveyProps) => (
  <div
    className={`condensed-report${
      containerClassName ? ` ${containerClassName}` : ""
    }${editing ? " editing" : ""}`}
  >
    <Survey model={model} />
  </div>
);

export default CondensedReportSurvey;
